<button
  mat-icon-button
  [matTooltip]="'TOGGLE_LEFT_SIDEBAR' | transloco"
  (click)="onClickToggleLeftSidebar()"
>
  <mat-icon>menu</mat-icon>
</button>
